/**
 * LOGO SERVA — sceau plein + logotype ponctué : le point vert clôt le mot.
 * Tout en SVG : net du favicon 16 px à l'affiche. Le point vert est la signature.
 */
import React from "react";
import { Link } from "react-router-dom";

const SERIF = "'Playfair Display', Georgia, serif";

/** Le monogramme : un S serif dans un disque. Lisible jusqu'en 16 px. */
export function Sceau({ taille = 32, fond = "var(--accent)", lettre = "#F7F7F5", className = "" }) {
  return (
    <svg
      width={taille}
      height={taille}
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label="Servae"
      style={{ display: "block", flexShrink: 0 }}
    >
      <circle cx="50" cy="50" r="50" fill={fond} />
      <text
        x="50"
        y="50"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily={SERIF}
        fontWeight="600"
        fontSize="62"
        fill={lettre}
      >
        S
      </text>
      <circle cx="72" cy="70" r="4.6" fill={lettre} opacity="0.9" />
    </svg>
  );
}

/** Le mot, ponctué du point vert : « Servae. » */
export function Mot({ hauteur = 26, couleur = "var(--text)", point = "var(--accent)" }) {
  return (
    <svg
      height={hauteur}
      viewBox="0 0 184 72"
      role="img"
      aria-label="Servae"
      style={{ display: "block", overflow: "visible" }}
    >
      <text
        x="0"
        y="52"
        fontFamily={SERIF}
        fontWeight="600"
        fontSize="56"
        letterSpacing="-1.5"
        fill={couleur}
      >
        Servae
      </text>
      <circle cx="168" cy="47" r="5.5" fill={point} />
    </svg>
  );
}

/**
 * La marque verrouillée : sceau + mot.
 * `compact` n'affiche que le sceau (barres serrées, favicon, avatar).
 */
export function Marque({
  taille = 26,
  lien = true,
  vers = "/journee",
  compact = false,
  sombre = false,
  testid = "marque",
}) {
  const couleur = sombre ? "#F7F7F5" : "var(--text)";
  const point = sombre ? "#F7F7F5" : "var(--accent)";
  const contenu = (
    <span className="inline-flex items-center gap-2.5 select-none">
      <Sceau
        taille={Math.round(taille * 1.22)}
        fond={sombre ? "#F7F7F5" : "var(--accent)"}
        lettre={sombre ? "var(--accent)" : "#F7F7F5"}
      />
      {!compact && <Mot hauteur={taille} couleur={couleur} point={point} />}
    </span>
  );
  return lien ? (
    <Link to={vers} data-testid={testid} style={{ color: couleur }}>
      {contenu}
    </Link>
  ) : (
    <span data-testid={testid} style={{ color: couleur }}>
      {contenu}
    </span>
  );
}
